<!-- ── HEADER ─────────────────────────────────────────────────── -->
<div class="flex items-center justify-between px-5 py-4 border-b border-line">
  <div class="flex items-center gap-x-2.5">
    <div class="w-7 h-7 rounded-full bg-brand-soft flex items-center justify-center shrink-0">
      <mat-icon class="!text-[15px] !size-[15px] text-brand">celebration</mat-icon>
    </div>
    <div>
      <p class="font-semibold text-ink text-sm leading-tight">What's New</p>
      <p class="text-[11px] text-ink-soft leading-tight">{{formattedDate}}</p>
    </div>
  </div>
  <button (click)="close()"
          class="w-7 h-7 rounded-full bg-sand-soft hover:bg-line flex items-center justify-center transition-colors">
    <mat-icon class="!text-[14px] !size-[14px] text-ink-soft">close</mat-icon>
  </button>
</div>

<!-- ── ENTRIES ────────────────────────────────────────────────── -->
<div class="overflow-y-auto" style="max-height: 65vh">
  @for (entry of data.entries; track entry.title; let last = $last) {
    <div class="px-5 py-5" [class.border-b]="!last" [class.border-line]="!last">
      @if (entry.image) {
        <img [src]="entry.image" [alt]="entry.title"
             class="w-full rounded-xl mb-4 object-cover"
             style="max-height: 200px"
             loading="lazy" />
      }
      <p class="font-semibold text-ink text-[15px] mb-1">{{entry.title}}</p>
      <p class="text-ink-muted text-sm leading-relaxed">{{entry.description}}</p>
    </div>
  }
</div>

<!-- ── CTA ───────────────────────────────────────────────────── -->
<div class="px-5 py-4 border-t border-line bg-[#faf9f8]">
  <button (click)="close()" matRipple
          class="w-full flex items-center justify-center py-3 px-6 rounded-full
                 bg-ink text-white font-semibold text-sm
                 hover:bg-ink/90 transition-opacity">
    Got it!
  </button>
</div>
